import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import $ from 'jquery';
import { CellTree } from "../../cell.model";
import { Cell, CellClient } from "../../../backend/backendapi";
import { handleError, initClient } from "../../../../api";

type VSelectItem = { id: number, name: string };

@Component({
    name: 'MoveModal',
    components: { vSelect }
})
export default class MoveModal extends Vue {
    @Prop({ required: true })
    readonly cellTree!: CellTree[];

    //runtime
    private cell: Cell | null = null;
    private parentId: number | null = null;
    
    //api
    private readonly cellAPI = initClient(CellClient);

    public open(cell: Cell): void {
        this.cell = cell;
        this.parentId = this.findParentId(cell);
        $(this.$refs.modal!).modal('show');
    }

    public dismiss(): void {
        $(this.$refs.modal!).modal('hide');
    }

    private move(): void {
        if (!this.cell)
            return;
        console.log('setparent', this.parentId);
        this.cellAPI.setParent(this.cell.id, this.parentId ?? undefined)
            .then(_ => {
                this.$toasted.info(this.$t('txtSaved').toString());
                this.dismiss()
            })
            .catch(e => handleError(this.$toasted, this.$i18n, e));
        
        this.$emit('moved');
    }

    private findParentId(val: Cell | null): number | null {
        let findParentIdRecursive = (ct: CellTree[]): number | undefined => {
            return ct.find(e => e.children.some(c => c.item.id === val!.id))?.item.id
                || ct.map(e => findParentIdRecursive(e.children)).reduce((l, r) => l || r, undefined);
        }
        return val == null ? null : (findParentIdRecursive(this.cellTree) ?? 0);
    }

    //getter
    private get cellsForVSelect(): VSelectItem[] {
        let flatMapper = (tree: CellTree, prefix: string) => {
            return [{ id: tree.item.id!, name: prefix + tree.item.name! }]
                .concat(tree.children.map(e => flatMapper(e, prefix + tree.item.name! + ' > ')).reduce((l, r) => l.concat(r), []));
        };
        return [{ id: 0, name: "ROOT" }, ...this.filteredCells.map(e => flatMapper(e, '')).reduce((l, r) => l.concat(r), [])];
    }

    private get filteredCells(): CellTree[] {
        if (!this.cell) {
            return [];
        }
        let filter = (l: CellTree[]) => {
            return l.filter(ct => ct.item.id !== this.cell!.id).map(ct => {
                let ret = new CellTree();
                ret.item = ct.item;
                ret.children = filter(ct.children);
                return ret;
            });
        }
        return filter(this.cellTree);
    }
}